import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, args, change }) {
    switch (args?.type) {
      case 'open_apps_launcher_properties': {
        change(args.launcher)
        setFlowTo(normalizePath(props.viewPath, 'LauncherProps/Content'))
        return
      }

      case 'reFetch': {
        // Just let the refetch happen from the GraphQL query
        return
      }

      default: {
        console.error(`The action type ${args?.type} does not exist`)
        return
      }
    }
  }
}
